import { Controller } from '@hotwired/stimulus';

// Auto-fills the calculated measure's label from the chosen operation and operands, until the user
// edits it themselves. Operands are a Tom Select multiple, so we read selected option text in order.
export default class extends Controller {
  static targets = ['operationSelect', 'operandsSelect', 'labelInput'];

  connect() {
    this.labelEdited = this.hasLabelInputTarget && this.labelInputTarget.value.trim() !== '';
  }

  labelChanged() {
    this.labelEdited = this.labelInputTarget.value.trim() !== '';
  }

  changed() {
    if (this.labelEdited) return;
    this.updateLabel();
  }

  updateLabel() {
    if (!this.hasLabelInputTarget || !this.hasOperationSelectTarget || !this.hasOperandsSelectTarget) return;

    const operationOption = this.operationSelectTarget.options[this.operationSelectTarget.selectedIndex];
    const operation = operationOption ? operationOption.text : '';
    const operands = this.selectedOperandLabels();
    if (!operation || operands.length === 0) return;

    this.labelInputTarget.value = `${operation} of ${operands.join(', ')}`;
  }

  selectedOperandLabels() {
    return Array.from(this.operandsSelectTarget.selectedOptions).map((option) => option.text);
  }
}
